import { profileUrl } from '../api/tmdb'
import { IconTarget, IconCheck } from './icons'

const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='185' height='278' viewBox='0 0 185 278'%3E%3Crect fill='%23333' width='185' height='278'/%3E%3Ccircle fill='%23555' cx='92' cy='100' r='40'/%3E%3Cellipse fill='%23555' cx='92' cy='220' rx='60' ry='50'/%3E%3C/svg%3E"

export default function FlipActorCard({ actor, onExpand, isTarget, isInChain }) {
  const handleActivate = (e) => {
    if (isInChain) return
    const rect = e.currentTarget.getBoundingClientRect()
    onExpand('actor', actor, rect)
  }

  return (
    <div
      className={[
        'grid-card grid-card--actor',
        isTarget ? 'grid-card--target' : '',
        isInChain ? 'grid-card--in-chain' : '',
      ].join(' ').trim()}
      onClick={handleActivate}
      role={isInChain ? undefined : 'button'}
      tabIndex={isInChain ? -1 : 0}
      onKeyDown={(e) => !isInChain && e.key === 'Enter' && handleActivate(e)}
      aria-label={
        isInChain
          ? `${actor.name} — already in chain`
          : `${actor.name}${isTarget ? ' — goal actor' : ''} — tap to see details`
      }
    >
      <img
        src={profileUrl(actor.profile_path) || PLACEHOLDER}
        alt={actor.name}
        className="grid-card__img"
        onError={(e) => { e.target.src = PLACEHOLDER }}
      />
      <div className="grid-card__footer">
        <span>{actor.name}</span>
        {isTarget && <span className="grid-card__target-badge"><IconTarget size={12} style={{ verticalAlign: 'middle' }} /> Goal</span>}
        {isInChain && <span className="grid-card__chain-badge"><IconCheck size={12} style={{ verticalAlign: 'middle' }} /> Used</span>}
      </div>
    </div>
  )
}
